import { Fragment } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { getApplicationStatus } from '../../../../api/lendingAPI/ApplicationSelector';
import { DateInput } from '../../../../forms/dateInput/index';
import { NameField } from '../../../../forms/nameField/index';
import { getCountry } from '../../../../iwIntlProvider/CountryProvider';
import { formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import messages from '../PersonModal.messages';
import companyPositionMessages from '../../../../helpers/companyPositions.messages';
import { FormField } from '../../../../forms/formField/FormField';
import styles from './PersonDetails.module.css';
import { Tooltip } from '@iwoca/orion';
import { RootState } from '@iwProvider/configureStore';

const selector = formValueSelector('person');
const mapStateToProps = (state: RootState) => ({
    ...state.personModal,
    hasCreditDecision: getApplicationStatus(state) !== 'open',
    isGuarantor: selector(state, 'isGuarantor')
});

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

const PersonDetails = (props: PropsFromRedux) => {
    const intl = useIntl();

    const { hasCreditDecision, isEditingPerson, isGuarantor } = props;
    const personalDetailsEditingDisabled =
        hasCreditDecision && isEditingPerson && isGuarantor;
    return (
        <>
            <NameField
                name="full_name"
                label={<FormattedMessage {...messages.fullName} />}
                disabled={personalDetailsEditingDisabled}
            />
            <DateInput
                name="dateOfBirth"
                label={<FormattedMessage {...messages.dateOfBirth} />}
                disabled={personalDetailsEditingDisabled}
            />
            <label>
                <FormattedMessage {...messages.roleTitle} />
            </label>
            <FormField
                className={styles.checkboxGroup}
                name="isDirector"
                type="checkbox"
                label={
                    <FormattedMessage {...companyPositionMessages.director} />
                }
            />
            <FormField
                className={styles.checkboxGroup}
                name="isShareholder"
                type="checkbox"
                label={
                    <FormattedMessage
                        {...companyPositionMessages.shareholder}
                    />
                }
            />
            {getCountry() === 'UK' ? (
                <div>
                    <div
                        className={styles.guarantorCheckbox}
                        data-tip
                        data-for="contactTooltip"
                    >
                        <FormField
                            className={styles.checkboxGroup}
                            name="isGuarantor"
                            data-testid="isGuarantor"
                            type="checkbox"
                            disabled={hasCreditDecision}
                            label={
                                <FormattedMessage
                                    {...companyPositionMessages.guarantor}
                                />
                            }
                        />
                        {hasCreditDecision ? (
                            <Tooltip
                                content={intl.formatMessage(
                                    messages.contactToolTip
                                )}
                                placement="right"
                                data-testid="contactTooltip"
                            />
                        ) : null}
                    </div>

                    {isGuarantor ? (
                        <div
                            className={styles.privacyPolicy}
                            data-testid="privacyPolicy"
                        >
                            <FormattedMessage
                                {...messages.privacyPolicy}
                                values={{
                                    privacyPolicyLink: (
                                        <a
                                            href="https://www.iwoca.co.uk/privacy-policy/"
                                            rel="noopener noreferrer"
                                            target="_blank"
                                        >
                                            <FormattedMessage
                                                {...messages.privacyPolicyLink}
                                            />
                                        </a>
                                    )
                                }}
                            />
                        </div>
                    ) : null}
                </div>
            ) : null}
        </>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(PersonDetails);
